import React from "react";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

import { Subjects } from "../../helper"

import "../../assets/stlyes/ClassHome/ClassHome.scss";
import "../../assets/stlyes/BigPicture/CurriculumCoverage.scss"

import ClassHomeUnChecked from "../../assets/images/ClassHomeUnChecked.svg";
import ClassHomeMathsCheckBox from "../../assets/images/ClassHomeMathsCheckBox.svg"
import ClassHomeReadingCheckBox from "../../assets/images/ClassHomeReadingCheckBox.svg"
import ClassHomeScienceCheckBox from "../../assets/images/ClassHomeScienceCheckBox.svg"
import ClassHomeWritingCheckBox from "../../assets/images/ClassHomeWritingCheckBox.svg"
import ClassHomePECheckBox from "../../assets/images/ClassHomePECheckBox.svg"

const ClassHomeCheckBox = (props) => {
  const { subjects, setSubjects,page } = props;
  const checkboxClass = page === "Coverage"? "_checkbox-container":"checkbox-container"

  const handleCheckboxChange = (subjectToChange) => {
    const updatedSubjects = subjects.map((subject) => {
      if (subject.subject === subjectToChange.subject) {
        return { ...subject, isChecked: !subject.isChecked };
      }
      return subject;
    });
    setSubjects(updatedSubjects);
  };

  return (
    <div className={checkboxClass}>
      {subjects.map((subject, index) => (
        <FormControlLabel
          key={index}
          control={
            <Checkbox
              checked={subject.isChecked}
              onChange={() => handleCheckboxChange(subject)}
              icon={
                <img
                  className="subjectsCheckBox-image"
                  src={ClassHomeUnChecked}
                  alt="unchecked"
                />
              }
              checkedIcon={
                subject.subject === Subjects.Maths
                  ? <img
                    className="subjectsCheckBox-image"
                    src={ClassHomeMathsCheckBox}
                    alt="checked"
                  />
                  : subject.subject === Subjects.Reading
                    ? <img
                      className="subjectsCheckBox-image"
                      src={ClassHomeReadingCheckBox}
                      alt="checked"
                    />
                    : subject.subject === Subjects.Science
                      ? <img
                        className="subjectsCheckBox-image"
                        src={ClassHomeScienceCheckBox}
                        alt="checked"
                      />
                      : subject.subject === Subjects.Writing
                        ? <img
                          className="subjectsCheckBox-image"
                          src={ClassHomeWritingCheckBox}
                          alt="checked"
                        />
                        : subject.subject === Subjects.PE
                          ? <img
                            className="subjectsCheckBox-image"
                            src={ClassHomePECheckBox}
                            alt="checked"
                          />
                          : null
              }
            />
          }
          label={
            <span className="subjectsCheckBox-name">{subject.subject}</span>
          }
        />
      ))}
    </div>
  );
};

export { ClassHomeCheckBox };
